var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shape-wrapper"},[_c('div',{staticClass:"shape shape-bottom shape-fluid-x",class:_vm.css},[_c('svg',{attrs:{"viewBox":"0 0 1440 140","fill":"none","preserveAspectRatio":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 80 L0 180 L1440 140 L1440 0 L300 140 Z","fill":"currentColor"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }